/**
 * Created by tomers on 2/26/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var IntegrationsPropertiesCollection = require("manager-collections/data-sources/integrations/IntegrationsPropertiesCollection");

    var KEYS = {
        ID: "id",
        PARENT_ID: "parentId",
        NAME: "name",
        METRIC_NAME: "metricName",
        CONNECTIONS: "connections",
        HAS_NO_SERVICES: "hasNoServices",
        NO_SERVICE_TOOLTIP_TEXT: "noServiceTooltipText",
        HAS_SCRAPER_TAB: "hasScraperTab",
        HAS_CODE_TAB: "hasCodeTab",
        AGENT_OUTCOME: "agentOutcome",
        AGENT_OUTCOME_SKILLS: "agentOutcome.skills",
        PROPERTIES: "properties",
        TOOLTIP: "tooltip",
        SKILLS: "skills"
    };

    var CONNECTION_STATUS = {
        UNKNOWN: "unknown",
        NONE: "none",
        PARTIAL: "partial",
        FULLY: "fully"
    };

    var IntegrationsAttributeModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        IntegrationsAttributeModel = BaseModel.extend({
            defaults : {
                "id": null,
                "parentId": null,
                "name": "",
                "metricName": "",
                "connections": -1,
                "hasNoServices": false,
                "noServiceTooltipText": "",
                "hasScraperTab": true,
                "hasCodeTab": true,
                "properties": [],
                "tooltip": [],
                "agentOutcome": false
            },
            name: "IntegrationsAttributeModel",

            initialize: function(options){
                this.hasUnsavedAgentOutcomeProperties = false;
                this.hasUnsavedScraperProperties = false;
            },

            getId: function(){
                return this.get(KEYS.ID);
            },
            getLogicalName: function(){
                return this.get(KEYS.NAME);
            },
            getName: function(){
                return LE.translator.translate('LEManager.dataSources.tab.integrations.attribute.' + this.getLogicalName() + ".title");
            },
            getDescription: function(){
                return LE.translator.translate('LEManager.dataSources.tab.integrations.attribute.' + this.getLogicalName() + ".description");
            },
            getLogicalButtonName: function(){
                return this.get(KEYS.BUTTON_NAME);
            },
            getParentId: function(){
                return this.get(KEYS.PARENT_ID);
            },
            getMetricName: function(){
                return this.get(KEYS.METRIC_NAME);
            },
            getConnections: function(){
                return this.get(KEYS.CONNECTIONS);
            },
            setConnections: function(connections){
                this.set(KEYS.CONNECTIONS, connections);
            },
            isConnected: function(){
                return this.getConnections() > 0;
            },
            getConnectionStatus: function(){
                if (!this.isConnected() && this.getConnections() === -1){
                    return CONNECTION_STATUS.UNKNOWN;
                }
                else {
                    return (this.getConnections() === 0) ? CONNECTION_STATUS.NONE : CONNECTION_STATUS.FULLY;
                }
            },
            hasNoServices: function(){
                return this.get(KEYS.HAS_NO_SERVICES);
            },
            getNoServiceTooltipText: function(){
                return LE.translator.translate(this.get(KEYS.NO_SERVICE_TOOLTIP_TEXT));
            },
            getConnectionTooltip: function(){
                return LE.translator.translate("LEManager.dataSources.tab.integrations.attribute." + this.getLogicalName() + ".tooltip.status.connected");
            },
            hasScraperTab: function(){
                return this.get(KEYS.HAS_SCRAPER_TAB);
            },
            hasCodeTab: function(){
                return this.get(KEYS.HAS_CODE_TAB);
            },
            getAgentOutcome: function(){
                return this.get(KEYS.AGENT_OUTCOME);
            },
            getProperties: function(){
                return this.get(KEYS.PROPERTIES);
            },
            getTooltipObject: function(){
                return this.get(KEYS.TOOLTIP);
            },
            getAgentOutcomeSkills: function() {
                return this.get(KEYS.AGENT_OUTCOME_SKILLS);
            },
            setAgentOutcome: function(value, options) {
                if (!_.isUndefined(options)) {
                    this.set(KEYS.AGENT_OUTCOME, value, options);
                }
                else {
                    this.set(KEYS.AGENT_OUTCOME, value);
                }
            },
            setAgentOutcomeSkills: function(value, options){
                value = _.isUndefined(value) ? [] : value; //fallback in case not saved correctly

                if (!_.isUndefined(options)){
                    this.set(KEYS.AGENT_OUTCOME_SKILLS, value, options);
                }
                else {
                    this.set(KEYS.AGENT_OUTCOME_SKILLS, value);
                }
            },
            getPropertiesCollection: function(){
                if (_.isUndefined(this.propertiesCollection)){
                    this.propertiesCollection = new IntegrationsPropertiesCollection(this.getProperties());
                }
                return this.propertiesCollection;
            },
            arePropertiesBlank: function(agent){
                var result = agent ? !this.getAgentOutcomeSkills() : true;
                var models;
                var model;
                var iterator;

                if (result) {
                    models = this.getPropertiesCollection().models;
                    iterator = models.length;
                    while (result && iterator) {
                        iterator--;
                        model = models[iterator];
                        result = result && model.arePropertiesBlank(agent);
                    }
                }

                return result;
            },
            arePropertiesValid: function(){
                var result = this.getPropertiesCollection().areModelsValid();
                return result;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    IntegrationsAttributeModel.KEYS = KEYS;
    IntegrationsAttributeModel.CONNECTION_STATUS = CONNECTION_STATUS;

    return IntegrationsAttributeModel;
});
